import { render, staticRenderFns } from "./copyLinkBtn.vue?vue&type=template&id=8cf83dd0&scoped=true"
import script from "./copyLinkBtn.vue?vue&type=script&lang=js"
export * from "./copyLinkBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf83dd0",
  null
  
)

export default component.exports